import React, { useState } from "react";
import { toast } from "sonner";
import { X, Sparkles, Ban } from "lucide-react";
import { BackgroundBlur, supportsBackgroundProcessors } from "@livekit/track-processors";

const BACKGROUND_OPTIONS = [
  { id: "none", label: "None" },
  { id: "blur", label: "Blur" },
];

/** Client-side virtual backgrounds / blur, applied to the local camera track
 * via `@livekit/track-processors` before it's published to the LiveKit room. */
export function VirtualBackgroundPanel({ localVideoTrack, onClose }) {
  const [active, setActive] = useState("none");
  const [busy, setBusy] = useState(false);

  const apply = async (optionId) => {
    if (!localVideoTrack) { toast.error("Turn your camera on first"); return; }
    if (!supportsBackgroundProcessors()) { toast.error("Your browser doesn't support virtual backgrounds"); return; }
    setBusy(true);
    try {
      if (optionId === "none") {
        await localVideoTrack.stopProcessor();
      } else if (optionId === "blur") {
        await localVideoTrack.setProcessor(BackgroundBlur(12));
      }
      setActive(optionId);
    } catch {
      toast.error("Could not apply background effect");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[60] px-4" data-testid="virtual-background-modal">
      <div className="glass-panel rounded-2xl p-6 max-w-sm w-full">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading text-lg font-semibold text-white flex items-center gap-2"><Sparkles className="w-5 h-5 text-cyan-400" /> Virtual Background</h3>
          <button onClick={onClose} data-testid="virtual-background-close-btn" className="text-slate-400 hover:text-white"><X className="w-5 h-5" /></button>
        </div>
        <div className="grid grid-cols-2 gap-3">
          {BACKGROUND_OPTIONS.map((opt) => (
            <button key={opt.id} onClick={() => apply(opt.id)} disabled={busy} data-testid={`virtual-background-option-${opt.id}`}
              className={`flex flex-col items-center gap-2 py-4 rounded-xl border text-sm ${active === opt.id ? "border-cyan-400 bg-cyan-500/10 text-cyan-300" : "border-white/10 bg-white/5 text-slate-300 hover:bg-white/10"}`}>
              {opt.id === "none" ? <Ban className="w-5 h-5" /> : <Sparkles className="w-5 h-5" />}
              {opt.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
